
export class Profile {
  public id: number;
  public name: string;
  public type: string;
  public product: string;
  public selectedWidgetConfigurationIds: number[];
  public clientRefs: number[];
  public clientParentIds: number[];
  public supplierRefs: number[];
  public creditorRefs: number[];
}

